import { ClientError, request } from 'graphql-request';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import authService from 'src/services/auth-service';

export const executeEngineQuery = async <T>(
    endpoint: string,
    query: string,
    variables: object
): Promise<{ data: T } | { error: FetchBaseQueryError }> => {
    try {
        const accessToken = await authService.getAccessToken();

        if (!accessToken) {
            return {
                error: {
                    status: 401,
                    data: 'No access token available',
                    message: 'Authentication required',
                },
            };
        }

        const data = await request<T>(endpoint, query, variables, { authorization: accessToken });

        return { data };
    } catch (error) {
        if (error instanceof ClientError) {
            if (error.response.status === 401) {
                return {
                    error: {
                        status: 401,
                        data: error.response.data,
                        response: { errors: error.response.errors },
                        message: 'Authentication required',
                    },
                };
            }

            console.error('Engine GraphQL error', {
                status: error.response.status,
                message: error.message,
                errors: error.response.errors,
            });

            return {
                error: {
                    status: error.response.status,
                    data: error.response.data,
                    response: { errors: error.response.errors },
                    message: error.message,
                },
            };
        }

        if (error instanceof Error && error.name === 'AbortError') {
            console.info('Engine GraphQL request was aborted');
            return {
                error: {
                    status: 'FETCH_ERROR',
                    error: 'Request was aborted',
                },
            };
        }

        console.error('Unexpected engine GraphQL error:', error);
        return {
            error: {
                status: 500,
                data: { message: 'An unexpected error occurred', error: (error as Error).message },
            },
        };
    }
};
